import { render, staticRenderFns } from "./DeliveryAddressPreview.vue?vue&type=template&id=4c5cfcd1"
import script from "./DeliveryAddressPreview.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressPreview.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAddressPreview.vue?vue&type=style&index=0&id=4c5cfcd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports